import useArraySearchParam, {
  ArraySearchParamActions,
} from './useArraySearchParam';

export default function useStringArraySearchParam(
  name: string
): [string[], ArraySearchParamActions<string>] {
  return useArraySearchParam<string>(name, {
    initialize: (s: string[]) => s.filter((v) => v),
  });
}
